/* eslint-disable prettier/prettier */
import React, { useEffect, useState, useMemo } from 'react';
// import {
//   deeperInsight as DeeperInsightResponse1,
//   getDashboardData as DashboardResponse,
//   peopleactivityQuery as PeopleActivitiesData,
//   portfolioGrossMargin as portfolioGrossMargin1,
//   report as ReportDataResponse,
// } from '../../../gql/types';
import { _t_ } from '../../../utils/translation/translation';
// import ActivityScores from '../ActivityScore/index';
// import { QueryResult, useQuery } from '@apollo/client';
// import {
//   GetDashboardData,
//   GetPeopleActivitiesData,
// } from '../../../gql/queries/dashboard';
// import { GetDeeperInsights } from '../../../gql/queries/deeperInsights';
// import { GetPortfolioGrossMargin } from '../../../gql/queries/grossMargin';

import { dates, quartersWithData } from '../../../config';
// import Loader from '../../atoms/Loader';

import { Avatar, Grid, makeStyles, Typography, Icon } from '@material-ui/core';
import ArrowBackButton from '@material-ui/icons/ArrowBack';
import { COLORS } from '../../../plTheme';
import { useGlobalStyles } from '../../../plStyles';
import ClosedSales from '../../molecules/ClosedSales';
import CircularProgressWidget from '../../molecules/CircularProgressWidget';
import ProductPortfolio from '../../molecules/ProductPortfolio';
import AvgDealSize from '../../molecules/AvgDealSize';
import ProductPenetrationWidget from '../ProductPenetrationWidget';
import ProductPenetrationGraph from '../../molecules/ProductPenetrationGraph';
import MyTeamTree from '../../molecules/MyTeamTree';
import Diversity from '../../molecules/Diversity';
import AttritionRate from '../../molecules/AttritionRate';
import RatingChartWidget from '../RatingChartWidget';
import AvgTimeToHire from '../../molecules/AvgTimeToHire';
// import LineGraph from '../../molecules/DepperInsightsGraph/index';
// import { GetReportData } from '../../../gql/queries/report';
// import ReportCompetenciesWidget from '../../molecules/ReportCompetenciesWidget';
import ReportSalesActivitiesWidget from '../../molecules/ReportSalesActivitiesWidget';
import ReportSalesOutcomeWidget from '../../molecules/ReportSalesOutcomeWidget';
// import { subtractDate } from '../../../utils/subtractDate/index';
import Footer from './footer';
import { ProductColorContext } from '../../../utils/productColorContext';
// import ReportCover from '../../../assets/ReportCover.png';
import CustomerLogo from '../../../assets/customer.svg';
import { format, utcToZonedTime } from 'date-fns-tz';
import ReactGA from 'react-ga';
// import moment from 'moment';
// import { getWeekDatesByNumber } from '../../../utils/helpers';
import CoachingPlan from './CoachingPlan';
import { generateWeeksOfYearWithQuarters } from '../../../utils/helpers';
// import { useHistory } from 'react-router';
import DiscoverySummary from './DiscoverySummary';
import OutcomeSummary from './OutcomeSummary';
import { ryanCharles, ryanJuan, discoveryDrivers } from '../../../config';
import ReportPLLogo from '../../../assets/HeaderIcons/PeopleLens_Logo.svg';
import ReportCoverPage from '../../../assets/report-cover-page.png';
import { getCookie } from '../../../utils/cookieUtils';
const weeks = generateWeeksOfYearWithQuarters(2025);

const repData: any = [
  {
    firstName: 'Ryan',
    lastName: 'Morgan',
    userId: '005UW000006cZcQYAU',
  },
  {
    firstName: 'Charles',
    lastName: 'Adams',
    userId: '0055f000008bIEvAAM',
  },
  {
    firstName: 'Juan',
    lastName: 'Carlos Forero',
    userId: '0055f000008bQ2QAAU',
  },
];

ReactGA.pageview('Manager Reports');

interface RecommendationItem {
  Component: string;
  [key: string]: any; // if there are other fields
}

interface Recommendation {
  Recommendations: RecommendationItem[];
  [key: string]: any;
}

export interface ReportsProps {
  activeQuarter: number;
  highPotentialUser: any;
  highPerformerUser: any;
  managerName: string;
  productId: string;
  productName: string;
  isRep: boolean;
  repId: string;
  activeWeek: number;
  setProgressValue: (value: number) => void;
}

const Reports: React.FC<ReportsProps> = ({
  activeQuarter,
  highPotentialUser,
  highPerformerUser,
  managerName,
  productId,
  productName,
  isRep,
  repId,
  activeWeek,
  setProgressValue,
}: ReportsProps) => {
  const datesTemp = [...dates];
  ReactGA.event({
    category: 'Manager Lens',
    action: 'Manager Reports',
  });
  const qtrValue = [1, 0, 2, 3][activeQuarter];
  const { ProductColorMap, setProductColorMap } = React.useContext(
    ProductColorContext,
  );

  // const history = useHistory();
  const QUARTER_NAMES = useMemo(() => [...Object.keys(quartersWithData)], [
    quartersWithData,
  ]);

  const [battleCardData, setBattleCardData] = useState<any>(ryanCharles);
  const [battleCardData1, setBattleCardData1] = useState<any>(ryanJuan);
  const [loader, setLoader] = useState(false);
  const [recommendationList, setRecommendationList] = useState<
    Recommendation[]
  >([]);

  // const {
  //   loading,
  //   error,
  //   data,
  //   refetch,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: '',
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: '',
  //           },
  //   },
  // });

  // const {
  //   loading: loading2,
  //   error: error2,
  //   data: data2,
  //   refetch: refetch2,
  // }: QueryResult<DeeperInsightResponse1> = useQuery(GetDeeperInsights, {
  //   variables: {
  //     dashboardInput: {
  //       startDate: dates?.[qtrValue].startDate,
  //       endDate: dates?.[qtrValue].endDate,
  //     },
  //   },
  // });
  // const {
  //   loading: loading6,
  //   error: error6,
  //   data: data6,
  //   refetch: refetch6,
  // }: QueryResult<portfolioGrossMargin1> = useQuery(GetPortfolioGrossMargin, {
  //   variables: {
  //     dashboardInput: {
  //       startDate: dates?.[qtrValue].startDate,
  //       endDate: dates?.[qtrValue].endDate,
  //     },
  //   },
  // });

  // const {
  //   loading: loading3,
  //   error: error3,
  //   data: data3,
  //   refetch: refetch3,
  // }: QueryResult<ReportDataResponse> = useQuery(GetReportData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //           },
  //   },
  // });

  // const {
  //   loading: loading10,
  //   error: error10,
  //   data: data4,
  //   refetch: refetch10,
  // }: QueryResult<ReportDataResponse> = useQuery(GetReportData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPerformerUser.userId,
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPerformerUser.userId,
  //           },
  //   },
  // });

  // const {
  //   loading: reportDataLoading,
  //   error: reportDataError,
  //   data: reportData1,
  //   refetch: reportDataRefetch,
  // }: QueryResult<ReportDataResponse> = useQuery(GetReportData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //           },
  //   },
  // });

  // const {
  //   loading: loading4,
  //   error: error4,
  //   data: highPerformerUserData,
  //   refetch: refetch4,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPerformerUser.userId,
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPerformerUser.userId,
  //           },
  //   },
  // });

  // const {
  //   loading: loading5,
  //   error: error5,
  //   data: highPotentialUserData,
  //   refetch: refetch5,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: highPotentialUser.userId,
  //           },
  //   },
  // });

  const getCoachingPlans = async () => {
    setLoader(true);
    try {
      const token = getCookie('accessToken') || '';
      let repIds = [
        '005UW000006cZcQYAU',
        '0055f000008bIEvAAM',
        '0055f000008bQ2QAAU',
      ];

      if (repId) repIds = [repId];
      const qtr = ['', 'H1_25', 'Q1_25', 'Q2_25'][qtrValue];

      const fetchPromises = repIds.map((repId) =>
        fetch(
          `${
            process.env.REACT_APP_API_BASE || ''
          }/api/getCoachingPlanByOpportunity`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              rep_id: repId,
              opportunity_id: '',
              mappingDriverType: '',
              quarter: activeWeek > -1 ? 'W30' : qtr,
            }),
          },
        ).then((response) => response.json()),
      );

      const results = await Promise.all(fetchPromises);
      setRecommendationList(results);
    } catch (error) {
      setLoader(false);
      console.error(error);
    } finally {
      setLoader(false);
    }
  };

  const getBattleCards = async () => {
    const token = getCookie('accessToken') || '';
    setBattleCardData([]);
    setLoader(true);
    await fetch(`${process.env.REACT_APP_API_BASE || ''}/api/getBattleCards`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        startDate: dates?.[qtrValue].startDate,
        endDate: dates?.[qtrValue].endDate,
        outcome: 'Quota Attainment',
        quarter: qtrValue,
        userId1: highPotentialUser.userId,
        userId2: highPerformerUser.userId,
      }),
    })
      .then(async (response) => {
        var jsonData = await response.json();
        setBattleCardData(jsonData);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
      });
  };

  // const {
  //   loading: loadingPeopleActivitiesFirstPerson,
  //   error: errorInPeopleActivitiesFirstPerson,
  //   data: peopleActivitiesDataFirstPerson,
  //   refetch: refetchPeopleActivitiesFirstPerson,
  // }: QueryResult<PeopleActivitiesData> = useQuery(GetPeopleActivitiesData, {
  //   variables: {
  //     dashboardInput: {
  //       startDate: dates?.[qtrValue].startDate,
  //       endDate: dates?.[qtrValue].endDate,
  //       userId: highPotentialUser.userId,
  //     },
  //     persona: '',
  //   },
  // });

  // const {
  //   loading: loadingPeopleActivitiesSecondPerson,
  //   error: errorInPeopleActivitiesSecondPerson,
  //   data: peopleActivitiesDataSecondPerson,
  //   refetch: refetchPeopleActivitiesSecondPerson,
  // }: QueryResult<PeopleActivitiesData> = useQuery(GetPeopleActivitiesData, {
  //   variables: {
  //     dashboardInput: {
  //       startDate: dates?.[qtrValue].startDate,
  //       endDate: dates?.[qtrValue].endDate,
  //       userId: highPerformerUser.userId,
  //     },
  //     persona: '',
  //   },
  // });

  // const {
  //   loading: loading9,
  //   error: error9,
  //   data: data9,
  //   refetch: refetch9,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: '',
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates?.[qtrValue].startDate,
  //             endDate: dates?.[qtrValue].endDate,
  //             userId: '',
  //           },
  //   },
  // });

  // const {
  //   loading: loading8,
  //   error: error8,
  //   data: data8,
  //   refetch: refetch8,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates[0].startDate,
  //             endDate: dates[3].endDate,
  //             userId: '',
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates[0].startDate,
  //             endDate: dates[3].endDate,
  //             userId: '',
  //           },
  //   },
  // });

  // const {
  //   loading: loadingBusinessOutcomesAnnual,
  //   error: errorBusinessOutcomesAnnual,
  //   data: dataBusinessOutcomesAnnual,
  //   refetch: refetchBusinessOutcomesAnnual,
  // }: QueryResult<DashboardResponse> = useQuery(GetDashboardData, {
  //   variables: {
  //     dashboardInput:
  //       productId != '-1'
  //         ? {
  //             startDate: dates[0].startDate,
  //             endDate:
  //               new Date().getDate() >= 15
  //                 ? moment(new Date())
  //                     .subtract(1, 'months')
  //                     .set('year', 2024)
  //                     .endOf('month')
  //                     .format('YYYY-MM-DD')
  //                 : moment(new Date())
  //                     .subtract(2, 'months')
  //                     .set('year', 2024)
  //                     .endOf('month')
  //                     .format('YYYY-MM-DD'),
  //             userId: '',
  //             productId: productId,
  //           }
  //         : {
  //             startDate: dates[0].startDate,
  //             endDate:
  //               new Date().getDate() >= 15
  //                 ? moment(new Date())
  //                     .subtract(1, 'months')
  //                     .set('year', 2024)
  //                     .endOf('month')
  //                     .format('YYYY-MM-DD')
  //                 : moment(new Date())
  //                     .subtract(2, 'months')
  //                     .set('year', 2024)
  //                     .endOf('month')
  //                     .format('YYYY-MM-DD'),
  //             userId: '',
  //           },
  //   },
  // });

  const useStyles = makeStyles({
    centerAligned: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
    },
    backArrow: {
      width: '8.5in',
      margin: '4px auto',
      borderRadius: '5px',
      pageBreakAfter: 'always',
      display: 'flex',
      gap: 5,
      alignItems: 'center',
    },
    page1: {
      width: '8.5in',
      height: '11.5in',
      padding: '14mm 10mm 0mm 10mm',
      margin: '5mm auto',
      boxSizing: 'border-box',
      border: '1px #D3D3D3 solid',
      borderRadius: '5px',
      background: 'white',
      boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
      pageBreakAfter: 'always',
      display: 'flex',
      'flex-direction': 'column',
      '&>:first-child': {
        flex: 1,
      },
    },
    coverPage: {
      width: '8.5in',
      height: '11.5in',
      padding: '10mm 10.5mm',
      margin: '6mm auto',
      boxSizing: 'border-box',
      border: '1px #D3D3D3 solid',
      borderRadius: '5px',
      background: 'white',
      boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
      pageBreakAfter: 'always',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      // backgroundImage: `url(${ReportCover}) !important`,
      // backgroundRepeat: 'no-repeat !important',
      // backgroundPosition: '100% 100% !important',
      // WebkitPrintColorAdjust: 'exact',
      // printColorAdjust: 'exact',
      // '@media print': {
      //   backgroundImage: `url(${ReportCover}) !important`,
      //   backgroundRepeat: 'no-repeat !important',
      //   backgroundPosition: '100% 100% !important',
      //   WebkitPrintColorAdjust: 'exact',
      //   printColorAdjust: 'exact',
      // },
    },
    footer: {
      padding: '5mm 0mm',
    },
    subpage: {
      padding: '1cm',
      border: '5px red solid',
      height: '257mm',
      outline: '2cm #FFEAEA solid',
    },
    mainTitle: {
      color: COLORS.TEXT_HIGH_EMPHASIS,
    },
    date: {
      color: COLORS.GENERAL_CHART_1,
      fontSize: '18px',
    },
    font300: {
      fontWeight: 300,
    },
    coverCenterImage: {
      height: 420,
      width: '100%',
    },
    footerImage: {
      height: 38,
      width: 128,
    },
    spanText: {
      marginRight: 20,
      textTransform: 'uppercase',
    },
    fullHeight: {
      height: '100%',
    },
    rightHeading: {
      color: COLORS.TEXT_LOW_EMPHASIS,
      marginRight: '21.94px',
      fontSize: 14,
    },
    rightHeading1: {
      color: COLORS.TEXT_HIGH_EMPHASIS,
      marginRight: '21.94px',
      marginTop: -5,
      fontWeight: 400,
    },
    widgets: {
      borderRadius: 4,
      border: '1px solid ' + COLORS.BORDER_PRIMARY,
      boxShadow: '0px 4px 18px 0px ' + COLORS.REPORTS_BOX_SHADOW,
      backgroundColor: COLORS.GENERAL_WHITE,
    },
    hideWhenPrint: {},
    [`@media print`]: {
      'html, body': {
        height: '100vh',
      },
      '@page': {
        margin: 0,
        padding: 0,
        width: '8.5in',
        height: '11.5in',
      },
      widgets: {
        boxShadow: 'none',
      },
      page: {
        boxShadow: 'none',
        margin: 0,
        border: 0,
        background: 'white',
      },
      hideWhenPrint: {
        pageBreakAfter: 'always',
        //   margin: '0mm 0mm 0mm 10mm',
        padding: '0mm',
        border: '0px',
        borderRadius: '0px',
        background: 'white',
        boxShadow: '0 0 0px rgba(0, 0, 0, 0.1)',
      },
    },
    page6Heading: {
      lineHeight: '20px',
    },
    page6HeadingComponent: {
      padding: '0px 25px',
    },
    page6Avatar: {
      width: '40px',
      height: '40px',
    },
    page6AvatarName: {
      width: 'max-content',
      lineHeight: '20px',
      // marginTop: -18,
    },
    hireDate: {
      width: 'max-content',
      lineHeight: '20px',
      fontSize: 12,
    },
    salesActivitiesHeading: {
      marginTop: 8,
      lineHeight: '20px',
      marginBottom: 8,
    },
    divStyle: {
      minHeight: '11in', // Use 11in instead of 11.5in to match your calculation
      height: 'auto', // Let content determine height naturally
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      // CSS for print media
      '@media print': {
        pageBreakInside: 'avoid',
        pageBreakAfter: 'always',
      },
    },
    skipPage: {
      '@media print': {
        display: 'none',
      },
    },
  });

  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const [reportOutcome, setReportOutcome] = useState(null);
  const [reportRepOutcome, setReportRepOutcome] = useState(null);
  // const handleTabChange = (num: number) => {
  //   setActiveTab(num);
  // };

  const getReportOutcomes = async () => {
    const token = getCookie('accessToken') || '';
    let timePeriod = ['2005_Q6', '2025_Q0', '2025_Q1', '2025_Q2'][qtrValue];
    if (activeWeek > -1) timePeriod = weeks[activeWeek].week;
    await fetch(`${process.env.REACT_APP_API_BASE || ''}/api/reportOutcomes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ timePeriod: timePeriod }),
    })
      .then(async (response) => {
        var jsonData = await response.json();
        setReportOutcome(jsonData);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getReportRepOutcomes = async () => {
    const token = getCookie('accessToken') || '';
    let timePeriod = ['2005_Q6', '2025_Q0', '2025_Q1', '2025_Q2'][qtrValue];
    if (activeWeek > -1) timePeriod = weeks[activeWeek].week;
    await fetch(
      `${process.env.REACT_APP_API_BASE || ''}/api/reportRepOutcomes`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          timePeriod: timePeriod,
          userIds: [
            '0055f000008bIEvAAM',
            '0055f000008bQ2QAAU',
            '005UW000006cZcQYAU',
          ],
        }),
      },
    )
      .then(async (response) => {
        var jsonData = await response.json();
        console.log(jsonData);
        setReportRepOutcome(jsonData);
        // setLoading(false);
      })
      .catch((err) => {
        // setLoading(false);
      });
  };

  useEffect(() => {
    getCoachingPlans();
    getReportOutcomes();
    getReportRepOutcomes();
    // setProductColorMap(data?.getDashboardData?.productColorMap);
    // getBattleCards();
  }, []);

  // if (loading2 || loading3 || loading10 || loading8 || loading9) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (error2) return <>`Error! ${error2.message}` </>;

  // if (loading) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (error) history.push('/logout');

  // if (loading3 || loading10) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (error3) return <>`Error! ${error3.message}` </>;
  // if (error10) return <>`Error! ${error10.message}` </>;

  // if (loading4) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (error4) return <>`Error! ${error4.message}` </>;

  // if (loading5) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (error5) return <>`Error! ${error5.message}` </>;

  // if (loadingPeopleActivitiesFirstPerson) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (errorInPeopleActivitiesFirstPerson)
  //   return <>`Error! ${errorInPeopleActivitiesFirstPerson.message}` </>;

  // if (loadingPeopleActivitiesSecondPerson) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (errorInPeopleActivitiesSecondPerson)
  //   return <>`Error! ${errorInPeopleActivitiesSecondPerson.message}` </>;

  // if (reportDataLoading) {
  //   return (
  //     <>
  //       <Loader />
  //     </>
  //   );
  // }
  // if (reportDataError) return <>`Error! ${reportDataError.message}` </>;

  // const dashboardData = data?.getDashboardData;
  // const dashboardDataAnnual = dataBusinessOutcomesAnnual?.getDashboardData;

  // const avgDealSize =
  //   dashboardData?.salesOutcome?.totalSalesClosed?.overallTotalSalesClosed &&
  //   dashboardData?.salesOutcome?.noOfDeals &&
  //   dashboardData?.salesOutcome?.totalSalesClosed?.overallTotalSalesClosed /
  //     dashboardData?.salesOutcome?.noOfDeals;

  // const avgDealSizeAnnual =
  //   dashboardDataAnnual?.salesOutcome?.totalSalesClosed
  //     ?.overallTotalSalesClosed &&
  //   dashboardDataAnnual?.salesOutcome?.noOfDeals &&
  //   dashboardDataAnnual?.salesOutcome?.totalSalesClosed
  //     ?.overallTotalSalesClosed / dashboardDataAnnual?.salesOutcome?.noOfDeals;

  const graphLenth = 2;
  // const graphSize = data2?.deeperInsight?.graphData
  //   ? data2?.deeperInsight?.graphData.length
  //   : 0;
  const rows = [];

  for (let i = 0; i < graphLenth; i++) {
    rows.push(i);
  }
  const xaxisRange = [
    [1, 5],
    [40, 80],
    [10, 50],
    [10, 50],
    [10, 100],
  ];
  const yaxisRange = [
    [30, 60],
    [30, 60],
    [200, 550],
    [300, 550],
    [10, 60],
  ];

  // Helper function to safely get coaching plan
  const getCoachingPlan = (repId: string) => {
    const rep = recommendationList.find((rep) => rep?.['Rep Id'] === repId);
    return rep?.['Coaching Plan'];
  };

  const ryanCoachingPlan: any = getCoachingPlan('005UW000006cZcQYAU');
  const charlesCoachingPlan: any = getCoachingPlan('0055f000008bIEvAAM');
  const juanCoachingPlan: any = getCoachingPlan('0055f000008bQ2QAAU');

  // for (let i = 0; i < graphSize; i = i + 2) {
  //   const f =
  //     data2?.deeperInsight?.graphData && data2?.deeperInsight?.graphData[i];
  //   if (i + 1 < graphSize) {
  //     const s =
  //       data2?.deeperInsight?.graphData &&
  //       data2?.deeperInsight?.graphData[i + 1];
  //     myMap.push({ id: i, array: [f, s] });
  //   } else {
  //     myMap.push({ id: i, array: [f] });
  //   }
  // }

  // const GrossMargin = [];
  // const GrossMarginLen = data6?.portfolioGrossMargin?.grossMarginData
  //   ? data6?.portfolioGrossMargin?.grossMarginData?.length
  //   : 0;
  // for (let i = 0; i < GrossMarginLen; i++) {
  //   const name =
  //     data6?.portfolioGrossMargin?.grossMarginData &&
  //     data6?.portfolioGrossMargin?.grossMarginData[i]?.productName;
  //   const value =
  //     data6?.portfolioGrossMargin?.grossMarginData &&
  //     data6?.portfolioGrossMargin?.grossMarginData[i]?.productPercentage;
  //   GrossMargin.push([name, value]);
  // }
  // const SalesCycle = [];
  // dashboardData?.salesOutcome?.totalSalesCycle;
  // const SalesCycleLen = dashboardData?.salesOutcome?.totalSalesCycle
  //   ? dashboardData?.salesOutcome?.totalSalesCycle?.length
  //   : 0;
  // for (let i = 0; i < SalesCycleLen; i++) {
  //   const name =
  //     dashboardData?.salesOutcome?.totalSalesCycle &&
  //     dashboardData?.salesOutcome?.totalSalesCycle[i]?.product?.name;
  //   const value =
  //     dashboardData?.salesOutcome?.totalSalesCycle &&
  //     dashboardData?.salesOutcome?.totalSalesCycle[i]?.productCycle;
  //   SalesCycle.push([name, value]);
  // }

  const persona = getCookie('persona');

  const selectedDate: any = datesTemp[qtrValue];

  const startDate = format(
    utcToZonedTime(new Date(selectedDate.startDate), 'UTC'),
    'MMM dd, yyyy',
  );

  const endDate = format(
    utcToZonedTime(new Date(selectedDate.endDate), 'UTC'),
    'MMM dd, yyyy',
  );
  //new Date(date).
  const formatDateToLocale = (date: any) =>
    date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
    });

  // const period = `${startDate.split(' ')[0]} - ${endDate.split(' ')[0]}`;
  const period = [
    '',
    `Jan 01 - Jun 30 (2025)`,
    `Jan 01 - Mar 31 (2025)`,
    `Apr 01 - Jun 30 (2025)`,
  ][qtrValue];
  const startPeriod = ['', `Jan 01, 2025`, `Jan 01, 2025`, `Apr 01, 2025`][
    qtrValue
  ];
  const endPeriod = ['', `Jun 30, 2025`, `Mar 31, 2025`, `Jun 30, 2025`][
    qtrValue
  ];

  // Helper function to determine if CoachingPlan content should be split into multiple pages
  const shouldSplitCoachingPlan = (elementObj: any) => {
    if (!elementObj) return false;

    const improvementOpportunity = elementObj?.['Improvement Opportunity'];
    const wdw =
      elementObj?.['What went well'] || elementObj?.['Whats Done Well'];

    // Split if Improvement Opportunities has more than 2 items
    if (
      improvementOpportunity &&
      Array.isArray(improvementOpportunity) &&
      improvementOpportunity.length > 2
    ) {
      return true;
    }

    // Split if What's Done Well has more than 2 items
    if (wdw && Array.isArray(wdw) && wdw.length > 2) {
      return true;
    }

    // Keep existing logic for other cases
    let sectionCount = 0;

    if (wdw && wdw.length > 0) sectionCount++;
    if (
      improvementOpportunity &&
      (Array.isArray(improvementOpportunity)
        ? improvementOpportunity.length > 0
        : true)
    )
      sectionCount++;
    if (
      elementObj?.['Rep Nudge'] &&
      (Array.isArray(elementObj['Rep Nudge'])
        ? elementObj['Rep Nudge'].length > 0
        : true)
    )
      sectionCount++;
    if (
      elementObj?.['Manager Nudge'] &&
      (Array.isArray(elementObj['Manager Nudge'])
        ? elementObj['Manager Nudge'].length > 0
        : true)
    )
      sectionCount++;

    // Split if we have 3+ sections total
    return sectionCount >= 3;
  };

  // Helper function to calculate content complexity for a page
  const calculatePageComplexity = (pageObj: any) => {
    let complexity = 0;

    const wdw = pageObj?.['What went well'] || pageObj?.['Whats Done Well'];
    const improvementOpportunity = pageObj?.['Improvement Opportunity'];
    const currentEntry =
      pageObj?.['Current Entry'] || pageObj?.['Currrent Entry'];
    const repNudge = pageObj?.['Rep Nudge'];
    const managerNudge = pageObj?.['Manager Nudge'];

    // WDW complexity
    if (wdw && Array.isArray(wdw)) complexity += wdw.length * 2;

    // IO complexity (higher weight due to dense content)
    if (improvementOpportunity && Array.isArray(improvementOpportunity)) {
      complexity += improvementOpportunity.length * 3;
      // Add extra weight if there are snippets
      if (currentEntry && Array.isArray(currentEntry)) {
        complexity += currentEntry.length * 2; // Increased weight for snippets
      }
    }

    // Nudge complexity
    if (repNudge)
      complexity += Array.isArray(repNudge) ? repNudge.length * 2 : 2;
    if (managerNudge)
      complexity += Array.isArray(managerNudge) ? managerNudge.length * 2 : 2;

    return complexity;
  };

  // Helper function to split elementObj into multiple pages
  const splitCoachingPlanContent = (
    elementObj: any,
    repName: string = 'Unknown',
  ) => {
    // Return empty array if elementObj is falsy
    if (!elementObj) {
      const emptyResult: any[] = [];
      return emptyResult;
    }

    if (!shouldSplitCoachingPlan(elementObj)) {
      return [elementObj]; // Return as single page
    }

    const wdw =
      elementObj?.['What went well'] || elementObj?.['Whats Done Well'];
    const improvementOpportunity = elementObj?.['Improvement Opportunity'];
    const currentEntry =
      elementObj?.['Current Entry'] || elementObj?.['Currrent Entry'];
    const repNudge = elementObj?.['Rep Nudge'];
    const managerNudge = elementObj?.['Manager Nudge'];
    const pages = [];

    // Check if we need to split WDW data
    const needsWDWSplit = wdw && Array.isArray(wdw) && wdw.length > 2;
    // Check if we need to split IO data
    const needsIOSplit =
      improvementOpportunity &&
      Array.isArray(improvementOpportunity) &&
      improvementOpportunity.length > 2;
    if (needsWDWSplit) {
      // Split WDW data into chunks of max 2 items each
      for (let i = 0; i < wdw.length; i += 2) {
        const wdwChunk = wdw.slice(i, i + 2);
        const isLastWDWChunk = i + 2 >= wdw.length;

        const page: any = {
          'What went well': wdwChunk,
          'Whats Done Well': wdwChunk,
          // Keep basic info for header
          'Score (1-10)': elementObj?.['Score (1-10)'],
          Score: elementObj?.['Score'],
        };

        // Add other sections only to the last WDW page if there's no IO splitting needed
        if (isLastWDWChunk && !needsIOSplit) {
          // Check if adding all content would be too complex
          const testPage = {
            ...page,
            'Improvement Opportunity': improvementOpportunity,
            'Current Entry': currentEntry,
            'Currrent Entry': currentEntry,
            'Rep Nudge': repNudge,
            'Manager Nudge': managerNudge,
          };

          const complexity = calculatePageComplexity(testPage);

          if (complexity > 8) {
            // Too complex - add only IO sections to this page, nudges go to next page
            page['Improvement Opportunity'] = improvementOpportunity;
            page['Current Entry'] = currentEntry;
            page['Currrent Entry'] = currentEntry;
            pages.push(page);

            // Create separate page for nudges if they exist
            const hasRepNudgeContent =
              repNudge &&
              (Array.isArray(repNudge) ? repNudge.length > 0 : true);
            const hasManagerNudgeContent =
              managerNudge &&
              (Array.isArray(managerNudge) ? managerNudge.length > 0 : true);

            if (hasRepNudgeContent || hasManagerNudgeContent) {
              const nudgePage: any = {
                'Rep Nudge': hasRepNudgeContent ? repNudge : undefined,
                'Manager Nudge': hasManagerNudgeContent
                  ? managerNudge
                  : undefined,
                'Score (1-10)': elementObj?.['Score (1-10)'],
                Score: elementObj?.['Score'],
              };
              pages.push(nudgePage);
            }
            return pages; // Exit early since we handled all content
          } else {
            // Complexity is fine - add all content to this page
            page['Improvement Opportunity'] = improvementOpportunity;
            page['Current Entry'] = currentEntry;
            page['Currrent Entry'] = currentEntry;
            page['Rep Nudge'] = repNudge;
            page['Manager Nudge'] = managerNudge;
          }
        }

        pages.push(page);
      }

      // If IO also needs splitting, handle it separately
      if (needsIOSplit) {
        for (let i = 0; i < improvementOpportunity.length; i += 2) {
          const ioChunk = improvementOpportunity.slice(i, i + 2);
          const currentEntryChunk =
            currentEntry && Array.isArray(currentEntry)
              ? currentEntry.slice(i, i + 2)
              : undefined;
          const isLastIOChunk = i + 2 >= improvementOpportunity.length;

          const page: any = {
            'Improvement Opportunity': ioChunk,
            'Current Entry': currentEntryChunk,
            'Currrent Entry': currentEntryChunk,
            // Keep basic info for header
            'Score (1-10)': elementObj?.['Score (1-10)'],
            Score: elementObj?.['Score'],
          };

          // Add nudges only to the last IO page, but check complexity first
          if (isLastIOChunk) {
            const testPage = {
              ...page,
              'Rep Nudge': repNudge,
              'Manager Nudge': managerNudge,
            };

            const complexity = calculatePageComplexity(testPage);

            if (complexity > 8) {
              // Too complex - don't add nudges to this page, add them to separate page
              // Create separate page for nudges if they exist
              const hasRepNudgeContent =
                repNudge &&
                (Array.isArray(repNudge) ? repNudge.length > 0 : true);
              const hasManagerNudgeContent =
                managerNudge &&
                (Array.isArray(managerNudge) ? managerNudge.length > 0 : true);

              if (hasRepNudgeContent || hasManagerNudgeContent) {
                const nudgePage: any = {
                  'Rep Nudge': hasRepNudgeContent ? repNudge : undefined,
                  'Manager Nudge': hasManagerNudgeContent
                    ? managerNudge
                    : undefined,
                  'Score (1-10)': elementObj?.['Score (1-10)'],
                  Score: elementObj?.['Score'],
                };
                pages.push(nudgePage);
              }
            } else {
              // Complexity is fine - add nudges to this page
              page['Rep Nudge'] = repNudge;
              page['Manager Nudge'] = managerNudge;
            }
          }

          pages.push(page);
        }
      }
    } else if (needsIOSplit) {
      // First page: WDW + first 2 IO items
      const page1 = {
        'What went well': wdw,
        'Whats Done Well': wdw,
        'Improvement Opportunity': improvementOpportunity.slice(0, 2),
        'Current Entry':
          currentEntry && Array.isArray(currentEntry)
            ? currentEntry.slice(0, 2)
            : undefined,
        'Currrent Entry':
          currentEntry && Array.isArray(currentEntry)
            ? currentEntry.slice(0, 2)
            : undefined,
        // Keep basic info for header
        'Score (1-10)': elementObj?.['Score (1-10)'],
        Score: elementObj?.['Score'],
      };
      pages.push(page1);

      // Split remaining IO data into chunks of max 2 items each
      for (let i = 2; i < improvementOpportunity.length; i += 2) {
        const ioChunk = improvementOpportunity.slice(i, i + 2);
        const currentEntryChunk =
          currentEntry && Array.isArray(currentEntry)
            ? currentEntry.slice(i, i + 2)
            : undefined;
        const isLastIOChunk = i + 2 >= improvementOpportunity.length;

        const page: any = {
          'Improvement Opportunity': ioChunk,
          'Current Entry': currentEntryChunk,
          'Currrent Entry': currentEntryChunk,
          // Keep basic info for header
          'Score (1-10)': elementObj?.['Score (1-10)'],
          Score: elementObj?.['Score'],
        };

        // Add nudges only to the last IO page, but check complexity first
        if (isLastIOChunk) {
          const testPage = {
            ...page,
            'Rep Nudge': repNudge,
            'Manager Nudge': managerNudge,
          };

          const complexity = calculatePageComplexity(testPage);

          if (complexity > 8) {
            // Too complex - don't add nudges to this page, create separate page
            // Create separate page for nudges if they exist
            const hasRepNudgeContent =
              repNudge &&
              (Array.isArray(repNudge) ? repNudge.length > 0 : true);
            const hasManagerNudgeContent =
              managerNudge &&
              (Array.isArray(managerNudge) ? managerNudge.length > 0 : true);

            if (hasRepNudgeContent || hasManagerNudgeContent) {
              const nudgePage: any = {
                'Rep Nudge': hasRepNudgeContent ? repNudge : undefined,
                'Manager Nudge': hasManagerNudgeContent
                  ? managerNudge
                  : undefined,
                'Score (1-10)': elementObj?.['Score (1-10)'],
                Score: elementObj?.['Score'],
              };
              pages.push(nudgePage);
            }
          } else {
            // Complexity is fine - add nudges to this page
            page['Rep Nudge'] = repNudge;
            page['Manager Nudge'] = managerNudge;
          }
        }

        pages.push(page);
      }
    } else {
      // Regular splitting logic for other cases (3+ sections total)
      const page1 = {
        ...elementObj,
      };

      // Remove Rep Nudge and Manager Nudge from first page
      delete page1['Rep Nudge'];
      delete page1['Manager Nudge'];

      pages.push(page1);

      // Second page: Rep Nudge + Manager Nudge (only if they have actual content)
      const hasRepNudgeContent =
        repNudge && (Array.isArray(repNudge) ? repNudge.length > 0 : true);
      const hasManagerNudgeContent =
        managerNudge &&
        (Array.isArray(managerNudge) ? managerNudge.length > 0 : true);

      if (hasRepNudgeContent || hasManagerNudgeContent) {
        const page2 = {
          'Rep Nudge': hasRepNudgeContent ? repNudge : undefined,
          'Manager Nudge': hasManagerNudgeContent ? managerNudge : undefined,
          // Keep basic info for header
          'Score (1-10)': elementObj?.['Score (1-10)'],
          Score: elementObj?.['Score'],
        };
        pages.push(page2);
      }
    }
    return pages;
  };

  return (
    <>
      <div className={`${classes.backArrow} ${classes.skipPage}`}>
        <div
          style={{
            cursor: 'pointer',
            border: '1.4px #979797 solid',
            borderRadius: '50%',
            padding: 3,
          }}
        >
          <Icon
            component={ArrowBackButton}
            style={{
              color: '#171F46',
              fontSize: '1.7rem',
              fontWeight: 600,
            }}
            onClick={() => {
              setProgressValue(0);
            }}
          ></Icon>
        </div>
        {/* <span>Go Back</span> */}
      </div>

      <div id="reportPage1" className={classes.coverPage}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
          }}
        >
          <img
            src={CustomerLogo}
            alt="CustomerLogo"
            className={classes.footerImage}
          />
          <img
            src={ReportPLLogo}
            alt="ReportPLLogo"
            className={classes.footerImage}
          />
        </div>
        <div>
          <Typography
            style={{ fontSize: 42, fontWeight: 500, lineHeight: '45px' }}
          >
            Sales Insights Report -{' '}
            {activeWeek > -1
              ? `${weeks[activeWeek].label}`
              : QUARTER_NAMES[qtrValue]}
          </Typography>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
          <Typography style={{ fontSize: 30, fontWeight: 400 }}>
            {`Accelerating Sales Performance`}
          </Typography>
          <Typography style={{ fontSize: 30, fontWeight: 400 }}>
            {`with Al-Powered Coaching Insights`}
          </Typography>
        </div>
        <div>
          <img
            src={ReportCoverPage}
            alt="ReportCoverPage"
            className={classes.coverCenterImage}
          />
        </div>
        <div style={{ flexDirection: 'column', display: 'flex', gap: 20 }}>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 1 }}>
              Customer Name:
            </Typography>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 4 }}>
              REGOLOGY
            </Typography>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 1 }}>
              Report Title:
            </Typography>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 4 }}>
              Sales Insights Report -{' '}
              {activeWeek > -1
                ? `${weeks[activeWeek].label}`
                : QUARTER_NAMES[qtrValue]}
            </Typography>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 1 }}>
              Prepared For:
            </Typography>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 4 }}>
              Manager
            </Typography>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 1 }}>
              Start Date:
            </Typography>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 4 }}>
              {activeWeek > -1
                ? ` ${formatDateToLocale(weeks[activeWeek].start)}`
                : ` ${startPeriod}`}
            </Typography>
          </div>
          <div style={{ display: 'flex', flexDirection: 'row', gap: 12 }}>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 1 }}>
              End Date:
            </Typography>
            <Typography style={{ fontSize: 18, fontWeight: 300, flex: 4 }}>
              {activeWeek > -1
                ? ` ${formatDateToLocale(weeks[activeWeek].end)}`
                : ` ${endPeriod}`}
            </Typography>
          </div>
        </div>
        <div style={{ flexDirection: 'column', display: 'flex', gap: 6 }}>
          <Typography
            style={{ fontSize: 12, fontWeight: 300, fontStyle: 'italic' }}
          >
            CONFIDENTIAL AND PROPRIETARY
          </Typography>
          <Typography
            style={{ fontSize: 12, fontWeight: 300, fontStyle: 'italic' }}
          >
            This report contains confidential information intended solely for
            the recipient. Do not distribute without prior written consent from
            PeopleLens.
          </Typography>
        </div>
      </div>

      {!isRep && (
        <div id="reportPage4" className={`${classes.page1}`}>
          <Typography
            className={`${globalClasses.roboto500px20px32px} ${classes.mainTitle}`}
            style={{ flex: 5 }}
          >
            {`Sales Outcomes (${
              activeWeek > -1
                ? weeks[activeWeek].quarter
                : QUARTER_NAMES[qtrValue]
            })`}
          </Typography>
          <Grid
            container
            direction="row"
            spacing={2}
            style={{ marginTop: '5%', flex: 20 }}
          >
            <Grid item xs={5}>
              <div style={{ height: 173 }}>
                <ClosedSales
                  closed={reportOutcome?.[0]?.['total_bookings_sum'] || 0}
                  existingClosed={
                    reportOutcome?.[0]?.['total_pipeline_generated'] || 0
                  }
                  forecast={
                    activeWeek == -1 && qtrValue == 0 ? 1500000.0 : 750000
                  } // dashboardData?.salesOutcome?.totalSalesForecast || 0}
                  reportInd={'report2'}
                />
              </div>
            </Grid>
            <Grid item xs={3}>
              <div style={{ height: 174 }}>
                <CircularProgressWidget
                  title={_t_('Quota Attainment')}
                  percentage={0} //{dashboardData?.salesOutcome?.quotaAttainment}
                  variant={'small1'}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              {' '}
              <div style={{ height: 174 }}>
                <AvgDealSize
                  avgDealSize={reportOutcome?.[0]?.['avg_deal_size'] || 0} //{avgDealSize}
                  dealsClosed={
                    reportOutcome?.[0]?.['total_booked_deals_count'] || 0
                  } //{dashboardData?.salesOutcome?.noOfDeals}
                  dealsLostClosed={
                    reportOutcome?.[0]?.['total_closed_lost_count'] || 0
                  } //{dashboardData?.salesOutcome?.noLostDeals}
                  repInd={true}
                  isReport={true}
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            spacing={2}
            style={{ marginTop: '5%', flex: 15 }}
          >
            <Grid item xs={5}>
              <ProductPenetrationWidget
                penetrationData={null} //{dashboardData?.salesOutcome?.productPenetration}
                activeQuarter={1}
                totalDeals={0} //{dashboardData?.salesOutcome?.noOfDeals}
                reportInd={true}
              />
            </Grid>
            <Grid item xs={3}>
              <CircularProgressWidget
                title={_t_('Win Rate')}
                percentage={reportOutcome?.[0]?.['win_rate'] || 0} //{dashboardData?.salesOutcome?.winRate}
                variant={'rep'}
              />
            </Grid>
            <Grid item xs={4}>
              <CircularProgressWidget
                title={_t_('Portfolio Presented')}
                percentage={0} //{dashboardData?.salesOutcome?.portfolioPresented}
                variant={'rep'}
              />
            </Grid>
          </Grid>
          <Grid
            container
            direction="row"
            spacing={2}
            style={{ marginTop: '5%', flex: 40 }}
          >
            <Grid item xs={6}>
              {' '}
              <ProductPortfolio
                salesClosed={0}
                // {
                //   dashboardData?.salesOutcome?.totalSalesClosed
                //     ?.overallTotalSalesClosed
                // }
                data={null}
                // {dashboardData?.salesOutcome?.topProductContributors}
                // previousYearData={
                //   data9?.getDashboardData?.salesOutcome?.topProductContributors
                // }
                previousYearSalesClosed={0}
                // {
                //   data9?.getDashboardData?.salesOutcome?.totalSalesClosed
                //     ?.overallTotalSalesClosed
                // }
                isInReport
              />
            </Grid>
            <Grid item xs={6}>
              {' '}
              {
                <ProductPenetrationGraph
                  data={[]} //{SalesCycle}
                  activeQuarter={1}
                  reportInd={false}
                  chartTitle={'Sales cycle'}
                  xAxisTitile={'DAYS'}
                />
              }
            </Grid>
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}
      {!isRep && (
        <div
          id="reportPage5"
          className={`${classes.page1}`}
          style={{ display: 'none' }}
        >
          <Typography
            variant="subtitle2"
            className={`${globalClasses.roboto500px20px32px} ${classes.mainTitle}`}
            style={{ flex: 5 }}
          >
            {_t_('People Drivers')}
          </Typography>
          <Grid container direction="row" spacing={5} style={{ flex: 95 }}>
            <Grid item sm={8} xs={8}>
              <Grid container direction="column" spacing={5}>
                <Grid item>
                  <div className={classes.widgets}>
                    <MyTeamTree
                      data={null} //{dashboardData?.peopleDrivers?.myTeam}
                      isInReport={true}
                      onclick={null}
                    />
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{
                      width: '100%',
                      height: 47,
                      backgroundColor: '#D9D9D9',
                      opacity: 0.6,
                    }}
                    className={classes.widgets}
                  >
                    <Grid
                      container
                      direction="row"
                      alignItems="center"
                      className={classes.fullHeight}
                      style={{ paddingLeft: 16 }}
                    >
                      <Grid item>
                        <Typography
                          variant="subtitle1"
                          color="textSecondary"
                          className={`${globalClasses.body1WidgetTitle} ${classes.spanText}`}
                        >
                          {' '}
                          {_t_('Span/Levels')}
                        </Typography>
                      </Grid>
                      <Grid item>
                        <Typography
                          variant="h4"
                          color="textPrimary"
                          data-testid="spanLevelValue"
                        >
                          5/6
                          {/* {dashboardData?.peopleDrivers?.spanLevel?.span}/
                        {dashboardData?.peopleDrivers?.spanLevel?.level} */}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{
                      width: '100%',
                      height: 144,
                    }}
                    className={classes.widgets}
                  >
                    <Diversity
                      quarter={qtrValue}
                      male={0} //{dashboardData?.peopleDrivers?.diversity?.noOfMale}
                      female={0} //{dashboardData?.peopleDrivers?.diversity?.noOfFemale}
                      target={0}
                      // {
                      //   dashboardData?.peopleDrivers?.diversity?.targetCount
                      // }
                      targetYear={0}
                      // {
                      //   dashboardData?.peopleDrivers?.diversity?.targetYear
                      // }
                      total={0} //{dashboardData?.peopleDrivers?.diversity?.total}
                      reports={true}
                    />
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{
                      width: '100%',
                      height: 154,
                      display: 'flex',
                      flexDirection: 'row',
                      gap: 28,
                      borderRadius: 4,
                      boxShadow:
                        '0px 4px 18px 0px ' + COLORS.REPORTS_BOX_SHADOW,
                    }}
                  >
                    <Grid style={{ flex: '45%' }} className={classes.widgets}>
                      <AttritionRate
                        currVal={0}
                        // {
                        //   dashboardData?.peopleDrivers?.attrition
                        //     ?.rateInCurrentQuarter
                        // }
                        prevVal={0} //{
                        //   dashboardData?.peopleDrivers?.attrition
                        //     ?.rateInSameQuarterPreviousYear
                        // }
                      />
                    </Grid>
                    <Grid
                      container
                      direction="column"
                      style={{
                        padding: '20px 0px 8% 14px',
                        flex: '45%',
                        justifyContent: 'space-between',
                      }}
                      className={classes.widgets}
                    >
                      <Grid item>
                        <Typography
                          variant="subtitle2"
                          className={classes.rightHeading}
                        >
                          {_t_('REQS')}
                        </Typography>
                      </Grid>

                      <Grid item>
                        <Typography
                          variant="h1"
                          className={classes.rightHeading1}
                        >
                          {null}
                          {/* {dashboardData?.peopleDrivers?.requiredCandidates}{' '} */}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm={4} xs={4}>
              <Grid container direction="column" spacing={5}>
                <Grid item>
                  <div
                    style={{ width: 199, height: 593 }}
                    className={classes.widgets}
                  >
                    <RatingChartWidget
                      data={[]} //{dashboardData?.peopleDrivers?.competencies}
                      reports={true}
                    />
                  </div>
                </Grid>
                <Grid item>
                  <div
                    style={{ width: 199, height: 153 }}
                    className={classes.widgets}
                  >
                    <AvgTimeToHire
                      value={0} //{dashboardData?.peopleDrivers?.avgTimeToHire}
                    />
                  </div>
                </Grid>
              </Grid>
            </Grid>
            {/** ******************************* */}
            {/* <Grid item style={{ paddingTop: 142 }}></Grid> */}
            {/** ******************************* */}
          </Grid>
          <Footer
            activeQuarter={1}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}
      {!isRep && (
        <div id="reportPage7" className={`${classes.page1}`}>
          {/* <div className={classes.subpage}> */}
          <Grid container direction="column" style={{ gap: '10px' }}>
            <Grid
              container
              direction="row"
              justify="space-evenly"
              className={classes.page6HeadingComponent}
              style={{ height: '50px' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  padding: '0px 12px',
                }}
              >
                <Grid item xs={4} className={classes.centerAligned}>
                  <Typography
                    variant="subtitle2"
                    className={classes.page6Heading}
                    color="textSecondary"
                    align="left"
                  >
                    {_t_(
                      `Sales Outcomes (${
                        activeWeek > -1
                          ? weeks[activeWeek].quarter
                          : QUARTER_NAMES[qtrValue]
                      })`,
                    )}
                  </Typography>
                  {persona === 'LEADER' && (
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: 'Rubik',
                      }}
                    >
                      {_t_(`* All Products`)}
                    </span>
                  )}
                </Grid>
                <Grid item xs={4} className={classes.centerAligned}>
                  <Grid
                    container
                    direction="row"
                    style={{ gap: 8, justifyContent: 'center' }}
                  >
                    <Avatar src="" className={classes.page6Avatar} />
                    <Grid>
                      <Typography
                        variant="subtitle2"
                        className={classes.page6AvatarName}
                      >
                        {/* {highPotentialUser?.name} */}
                        Ryan Morgan
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={classes.hireDate}
                      >
                        (DoH: 11/24)
                        {/* {formatHireDate(highPotentialUser?.hire_date)} */}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4} className={classes.centerAligned}>
                  <Grid
                    container
                    direction="row"
                    style={{ gap: 8, justifyContent: 'center' }}
                  >
                    <Avatar src="" className={classes.page6Avatar} />
                    <Grid>
                      <Typography
                        variant="subtitle2"
                        // align="left"
                        className={classes.page6AvatarName}
                      >
                        {/* {highPerformerUser?.name} */}
                        Charles Adams
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={classes.hireDate}
                      >
                        (DoH: 01/22)
                        {/* {formatHireDate(highPerformerUser?.hire_date)} */}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <ReportSalesOutcomeWidget
              data1={null} //{highPotentialUserData?.getDashboardData?.salesOutcome}
              data2={null} //{highPerformerUserData?.getDashboardData?.salesOutcome}
              reportData={null} //{data3?.report}
              reportData1={null} //{data4?.report}
              isSecond={false}
              activeWeek={activeWeek}
            />
            {activeWeek === -1 && (
              <>
                <Grid item className={classes.page6HeadingComponent}>
                  <Typography
                    variant="subtitle2"
                    className={classes.salesActivitiesHeading}
                    color="textSecondary"
                    align="left"
                    style={{ marginBottom: 4 }}
                  >
                    {_t_('Drivers for Booking')}
                  </Typography>
                </Grid>
                <ReportSalesActivitiesWidget
                  data1={battleCardData?.battleCard?.[0]}
                  data2={battleCardData?.battleCard?.[1]}
                  loader={loader}
                  error={battleCardData?.battleCard?.[0]?.error}
                />
              </>
            )}
            {/* <Grid item>
            <Typography
              variant="subtitle2"
              className={classes.salesActivitiesHeading}
              color="textSecondary"
              align="left"
            >
              {_t_('Competencies')}
            </Typography>
          </Grid>
          <ReportCompetenciesWidget
            data1={
              highPotentialUserData?.getDashboardData?.peopleDrivers
                ?.competencies
            }
            data2={
              highPerformerUserData?.getDashboardData?.peopleDrivers
                ?.competencies
            }
          /> */}
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}

      {/* remove reportPage8 later */}
      {!isRep && (
        <div id="reportPage8" className={`${classes.page1}`}>
          {/* <div className={classes.subpage}> */}
          <Grid container direction="column" style={{ gap: '10px' }}>
            <Grid
              container
              direction="row"
              justify="space-around"
              className={classes.page6HeadingComponent}
              style={{ height: '50px' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  padding: '0px 12px',
                }}
              >
                <Grid item xs={4} className={classes.centerAligned}>
                  <Typography
                    variant="subtitle2"
                    className={classes.page6Heading}
                    color="textSecondary"
                    align="left"
                  >
                    {_t_(
                      `Sales Outcomes (${
                        activeWeek > -1
                          ? weeks[activeWeek].quarter
                          : QUARTER_NAMES[qtrValue]
                      })`,
                    )}
                  </Typography>
                  {persona === 'LEADER' && (
                    <span
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: 'Rubik',
                      }}
                    >
                      {_t_(`* All Products`)}
                    </span>
                  )}
                </Grid>
                <Grid item xs={4} className={classes.centerAligned}>
                  <Grid
                    container
                    direction="row"
                    style={{ gap: 8, justifyContent: 'center' }}
                  >
                    <Avatar src="" className={classes.page6Avatar} />
                    <Grid>
                      <Typography
                        variant="subtitle2"
                        className={classes.page6AvatarName}
                      >
                        {/* {highPotentialUser?.name} */}
                        Ryan Morgan
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={classes.hireDate}
                      >
                        (DoH: 11/24)
                        {/* {formatHireDate(highPotentialUser?.hire_date)} */}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={4} className={classes.centerAligned}>
                  <Grid
                    container
                    direction="row"
                    style={{ gap: 8, justifyContent: 'center' }}
                  >
                    <Avatar src="" className={classes.page6Avatar} />
                    <Grid>
                      <Typography
                        variant="subtitle2"
                        // align="left"
                        className={classes.page6AvatarName}
                      >
                        {/* {highPerformerUser?.name} */}
                        Juan Carlos Forero
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        className={classes.hireDate}
                      >
                        (DoH: 03/22)
                        {/* {formatHireDate(highPerformerUser?.hire_date)} */}
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </div>
            </Grid>
            <ReportSalesOutcomeWidget
              data1={null} //{highPotentialUserData?.getDashboardData?.salesOutcome}
              data2={null} //{highPerformerUserData?.getDashboardData?.salesOutcome}
              reportData={null} //{data3?.report}
              reportData1={null} //{data4?.report}
              isSecond={true}
              activeWeek={activeWeek}
            />
            {activeWeek === -1 && (
              <>
                <Grid item className={classes.page6HeadingComponent}>
                  <Typography
                    variant="subtitle2"
                    className={classes.salesActivitiesHeading}
                    color="textSecondary"
                    align="left"
                    style={{ marginBottom: 4 }}
                  >
                    {_t_('Drivers for Booking')}
                  </Typography>
                </Grid>
                <ReportSalesActivitiesWidget
                  data1={battleCardData1?.battleCard?.[0]}
                  data2={battleCardData1?.battleCard?.[1]}
                  loader={loader}
                  error={battleCardData1?.battleCard?.[0]?.error}
                />
              </>
            )}
            {/* <Grid item>
            <Typography
              variant="subtitle2"
              className={classes.salesActivitiesHeading}
              color="textSecondary"
              align="left"
            >
              {_t_('Competencies')}
            </Typography>
          </Grid>
          <ReportCompetenciesWidget
            data1={
              highPotentialUserData?.getDashboardData?.peopleDrivers
                ?.competencies
            }
            data2={
              highPerformerUserData?.getDashboardData?.peopleDrivers
                ?.competencies
            }
          /> */}
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}
      {!isRep && (
        <div id="reportPage8" className={`${classes.page1}`}>
          {/* <div className={classes.subpage}> */}
          <Grid container direction="column" style={{ marginTop: '-34px' }}>
            <OutcomeSummary
              reportRepOutcome={reportRepOutcome}
              timePeriod={
                activeWeek > -1
                  ? weeks[activeWeek].quarter
                  : QUARTER_NAMES[qtrValue]
              }
            />
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}

      {/* reportPage8 ends here */}
      {!isRep && (
        <div id="reportPage8" className={`${classes.page1}`}>
          {/* <div className={classes.subpage}> */}
          <Grid
            container
            direction="column"
            justify="space-between"
            style={{ marginTop: '-36px' }}
          >
            <DiscoverySummary
              recommendationList={recommendationList}
              timePeriod={
                activeWeek > -1
                  ? weeks[activeWeek].quarter
                  : QUARTER_NAMES[qtrValue]
              }
            />
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}
      {/* coaching plan */}
      {((!ryanCoachingPlan && repId == '005UW000006cZcQYAU') ||
        (!charlesCoachingPlan && repId == '0055f000008bIEvAAM') ||
        (!juanCoachingPlan && repId == '0055f000008bQ2QAAU')) && (
        <div id="reportPage8" className={`${classes.page1}`}>
          {/* <div className={classes.subpage}> */}
          <Grid
            container
            direction="column"
            justify="space-between"
            style={{ alignItems: 'center', marginTop: 10 }}
          >
            <Typography style={{ fontWeight: 400 }}>
              {loader ? 'Fetching Coaching Plan...' : 'No Coaching Plan Found'}
            </Typography>
          </Grid>
          <Footer
            activeQuarter={qtrValue}
            useAltLogo={true}
            period={activeWeek > -1 ? weeks[activeWeek].label : period}
          />
        </div>
      )}
      {
        [ryanCoachingPlan, charlesCoachingPlan, juanCoachingPlan]
          .map((coaching_plans: any, repIndex: number) => {
            // Skip if no coaching plan
            if (!coaching_plans) return null;

            return (
              <React.Fragment key={repIndex}>
                {coaching_plans &&
                  [
                    'agenda',
                    'purchase_journey',
                    'recommendation_evaluation_or_service_process',
                    'intro',
                    'level_setting',
                    'discovery',
                    'mutual_action_planning',
                    'next_steps',
                  ]
                    .map((item) => {
                      const coachingPlanList =
                        coaching_plans?.Opportunities[0]?.Recommendations;
                      const discoveryElement = discoveryDrivers[item];
                      let elementObj = coachingPlanList?.[discoveryElement];
                      const repFName = repData[repIndex]?.firstName;
                      const repLName = repData[repIndex]?.lastName;

                      // Split content into multiple pages if needed

                      const splitPages = splitCoachingPlanContent(
                        elementObj,
                        repFName,
                      );

                      return splitPages?.map((pageElementObj, pageIndex) => {
                        return (
                          <div
                            key={`${repFName}-${item}-page-${pageIndex}`}
                            id={`${repFName}${item}${pageIndex}reportPage8`}
                            className={`${classes.page1}`}
                          >
                            {/* <div className={classes.subpage}> */}
                            <Grid
                              container
                              direction="column"
                              justify="space-between"
                              style={{ marginTop: '-30px' }}
                            >
                              <CoachingPlan
                                repId={repData[repIndex]?.userId}
                                elementObj={pageElementObj}
                                repName={`${repFName} ${repLName}`}
                                driver={item}
                                activeQuarter={qtrValue}
                                activeWeek={activeWeek}
                                timePeriod={
                                  activeWeek > -1
                                    ? weeks[activeWeek].label
                                    : ['FSM', 'H1 25', 'Q1 25', 'Q2 25'][
                                        qtrValue
                                      ]
                                }
                                isMultiPage={
                                  splitPages && splitPages.length > 1
                                }
                                pageIndex={pageIndex}
                              />
                            </Grid>
                            <Footer
                              activeQuarter={qtrValue}
                              useAltLogo={true}
                              period={
                                activeWeek > -1
                                  ? weeks[activeWeek].label
                                  : period
                              }
                            />
                          </div>
                        );
                      });
                    })
                    .flat()}
              </React.Fragment>
            );
          })
          .filter(Boolean) // Remove null entries
      }
    </>
  );
};

export default Reports;
